
<app-navbar logoLink="/" profileLink="/profile"></app-navbar>
<div class="layout-row">
  <app-sidebar *ngIf="!appSidebar.hidden" [class.collapsed]="appSidebar.collapsed"></app-sidebar>
  <div class="layout-content" (click)="collapseSidebar()">
    <div class="animate-view" [@routeChanging]="routeLogger.routeChanging$|async">
      <router-outlet></router-outlet>
      <div class="angular-js-container" ng-view></div>
    </div>
    <div [hidden]="!(routeLogger.routeChanging$|async)" data-test-qa="loadingSpinner">
      <spinner-icon></spinner-icon>
    </div>
  </div>
</div>
<uploader-panel></uploader-panel>